module.exports = __webpack_public_path__ + "static/media/call-off.b6e33442.svg";